import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Label, Text } from "@amzn/stencil-react-components/text";
import Checkbox from "@amzn/uxm-stencil-react-components/lib/src/stencil/checkbox";
import React, { FunctionComponent, ReactElement, useState } from "react";

export interface AcknowledgmentInfo {
  id: string;
  input?: string;
  policies: string[];
  dataCy?: string;
  text?: ReactElement<any, any>;
  plainText?: string;
}

export interface AcknowledgmentsListProps {
  list?: AcknowledgmentInfo[];
  handleSingleCheck: (policies: string[], ack: boolean, input?: string) => void;
  handleReady: (ready: boolean) => void;
}

export const AcknowledgmentsList: FunctionComponent<AcknowledgmentsListProps> = (props: AcknowledgmentsListProps) => {
  const [ackCount, setAckCount] = useState<number>(0);

  if (props.list && props.list.length > 0) {
    const listItems = props.list.map((item) => {
      if (!item.text) {
        item.text = <Text>{item.plainText}</Text>;
      }
      return (
        <Row gridGap="S200" key={item.id + "_row"}>
          <Checkbox
            id={item.id}
            key={item.id}
            data-cy={item.dataCy}
            touchpoint={item.id}
            customData={{ text: item.text }}
            onChange={(e: any) => {
              props.handleSingleCheck(item.policies, e.target.checked, item.input);

              let realAckCount = ackCount;
              if (e.target.checked) {
                realAckCount++;
              } else {
                realAckCount--;
              }

              props.handleReady(realAckCount === props.list?.length);
              setAckCount(realAckCount);
            }}
          />
          <Label htmlFor={item.id} id={item.id + "_label"}>
            {item.text}
          </Label>
        </Row>
      );
    });

    return (
      <Col gridGap="S200" data-cy="acks-list">
        <br />
        {listItems}
      </Col>
    );
  } else {
    // Nothing to show, return an empty element.
    return <></>;
  }
};
